import { linkStrategy } from '@/App.datalayer';
import {
  DatalayerPopupContentTypes,
  DataLayerTrackEvents,
} from '@/datalayer/App.datalayer.constants';
import { OnDatalayerProps } from '@/features/shared/HOCs/withGTM.interface';

export const onDatalayerCloseStickyPopup = ({ target }: OnDatalayerProps) => {
  if (!target) {
    return undefined;
  }
  const { title } = target;

  return {
    event: DataLayerTrackEvents.EXIT_POPUP,
    event_name: 'exit_popup',
    content_type: DatalayerPopupContentTypes.STICKY_POPUP,
    ...(!!title && { title }),
  };
};

export const onDatalayer = ({ target }: OnDatalayerProps) => {
  return linkStrategy({ target });
};
